import { createAsyncThunk } from "@reduxjs/toolkit";
import { getData } from "../../utils/getData";

export const getInitiativeDetail = createAsyncThunk(
  "initiatives/getDetail",
  async (id, { rejectWithValue }) => {
    try {
      const response = await getData(
        `${process.env.REACT_APP_BASE_URL}api/initiatives/${id}`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch initiative");
    }
  }
);
